import React from 'react';
import { Conditional } from '@cashfree-intl/coherent';

const Rocket = ({ type = 'success' }: { type: string }) => (
  <>
    <Conditional if={type === 'success'}>
      <svg
        width="89"
        height="90"
        viewBox="0 0 89 90"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse
          cx="14.2938"
          cy="1.77678"
          rx="1.77996"
          ry="1.77678"
          fill="#EFE5FF"
        />
        <path
          d="M4.9902 54.6233C4.9902 55.2763 4.45973 55.8068 3.80387 55.8068C3.148 55.8068 2.61753 55.2763 2.61753 54.6233C2.61753 53.9703 3.148 53.4398 3.80387 53.4398C4.45973 53.4398 4.9902 53.9703 4.9902 54.6233Z"
          stroke="#EFE5FF"
          strokeWidth="0.791706"
        />
        <path
          d="M88.5153 25.5289C88.5153 26.0249 88.0362 26.515 87.329 26.515C86.6218 26.515 86.1427 26.0249 86.1427 25.5289C86.1427 25.0329 86.6218 24.5428 87.329 24.5428C88.0362 24.5428 88.5153 25.0329 88.5153 25.5289Z"
          stroke="#EFE5FF"
          strokeWidth="0.791706"
        />
        <ellipse
          cx="72.4846"
          cy="50.0714"
          rx="1.38441"
          ry="1.38194"
          fill="#EFE5FF"
        />
        <path
          d="M58.2059 7.92787L58.2059 5.93369L58.2041 5.90281C58.1848 5.75921 58.0677 5.65603 57.9285 5.65603C57.7882 5.65603 57.6705 5.76075 57.6532 5.89898L57.6512 5.92754L57.6509 7.92773L55.6584 7.92789L55.6273 7.92977C55.4964 7.94744 55.3987 8.04629 55.3831 8.17084L55.3811 8.1994L55.3828 8.23664C55.4005 8.36766 55.4992 8.46546 55.6237 8.48105L55.6522 8.48301L57.6512 8.48308L57.651 10.4774L57.6526 10.5059C57.6705 10.6503 57.7882 10.7551 57.9285 10.7551L57.957 10.7535L57.9853 10.7486C58.1148 10.7198 58.2059 10.6084 58.2059 10.4774L58.2061 8.48308L60.1986 8.4832L60.2271 8.48162C60.3714 8.46375 60.476 8.34595 60.476 8.20555C60.476 8.0522 60.3518 7.92789 60.1986 7.92789L58.2059 7.92787Z"
          fill="#EFE5FF"
        />
        <path
          d="M36.9323 67.5343L36.9323 66.0113L36.9309 65.9877C36.9161 65.8781 36.8265 65.7993 36.7199 65.7993C36.6124 65.7993 36.5223 65.8792 36.5091 65.9848L36.5076 66.0066L36.5073 67.5342L34.9817 67.5343L34.9579 67.5358C34.8576 67.5493 34.7828 67.6248 34.7709 67.7199L34.7694 67.7417L34.7707 67.7701C34.7842 67.8702 34.8598 67.9449 34.9551 67.9568L34.977 67.9583L36.5075 67.9584L36.5074 69.4815L36.5086 69.5033C36.5223 69.6136 36.6124 69.6935 36.7199 69.6935L36.7417 69.6923L36.7634 69.6886C36.8625 69.6666 36.9323 69.5816 36.9323 69.4815L36.9324 67.9584L38.458 67.9585L38.4799 67.9572C38.5903 67.9436 38.6705 67.8536 38.6705 67.7464C38.6705 67.6293 38.5754 67.5343 38.458 67.5343L36.9323 67.5343Z"
          fill="#EFE5FF"
        />
        <path
          d="M2.42392 24.4543L2.42391 22.8142L2.42238 22.7888C2.40652 22.6707 2.30994 22.5858 2.19513 22.5858C2.07945 22.5858 1.98239 22.6719 1.96814 22.7856L1.96652 22.8091L1.96623 24.4542L0.323238 24.4544L0.297626 24.4559C0.189671 24.4704 0.109089 24.5517 0.0962451 24.6542L0.0946241 24.6777L0.0960149 24.7083C0.110572 24.8161 0.192019 24.8965 0.294648 24.9093L0.318177 24.9109L1.96646 24.911L1.96636 26.5513L1.96766 26.5747C1.98239 26.6935 2.07945 26.7796 2.19513 26.7796L2.21865 26.7783L2.24199 26.7743C2.34874 26.7506 2.42391 26.659 2.42391 26.5513L2.42404 24.911L4.06703 24.9111L4.09054 24.9098C4.20952 24.8951 4.2958 24.7982 4.2958 24.6827C4.2958 24.5566 4.19337 24.4544 4.06702 24.4544L2.42392 24.4543Z"
          fill="#EFE5FF"
        />
        <g filter="url(#filter0_f_600_30739)">
          <path
            d="M73.0895 79.7704C73.0895 82.1507 61.7976 84.0803 47.8684 84.0803C33.9392 84.0803 22.6473 82.1507 22.6473 79.7704C22.6473 77.3901 33.9392 75.4604 47.8684 75.4604C61.7976 75.4604 73.0895 77.3901 73.0895 79.7704Z"
            fill="#C4C1FE"
            fillOpacity="0.4"
          />
        </g>
        <path
          d="M66.6734 31.584L57.455 27.4683V45.1976L69.5343 52.7959L66.6734 31.584Z"
          fill="#7C6AEA"
        />
        <path
          d="M28.477 31.584L36.8033 27.4683V45.1976L25.8929 52.7959L28.477 31.584Z"
          fill="#7C6AEA"
        />
        <path
          d="M47.324 52.8144V49.0291V45.2439V4.86816C47.324 4.86816 41.4368 7.37515 37.4334 19.2834C35.1303 26.134 34.0855 32.5303 33.499 39.2506C33.122 43.5693 33.3319 48.0828 33.6361 52.8144H36.3737V55.3378H39.5825V57.8613H47.324V55.3378V52.8144Z"
          fill="#DBD6FF"
        />
        <path
          d="M47.324 52.8144V49.0291L47.324 45.2439L47.324 4.86816C47.324 4.86816 53.3749 7.37515 57.4894 19.2834C59.8565 26.134 60.9303 32.5303 61.5331 39.2506C61.9205 43.5693 61.7048 48.0828 61.3922 52.8144H58.5786V55.3378H55.2806V57.8613H47.324V55.3378V52.8144Z"
          fill="#F2F0FF"
        />
        <path
          d="M44.2165 61.7583C46.2865 61.7583 47.7196 61.7583 51.2227 61.7583C55.078 61.7583 52.178 72.8657 51.2227 72.8657C50.2673 72.8657 47.7196 77.3445 47.7196 77.3445C47.7196 77.3445 45.6496 72.8657 44.2165 72.8657C42.7835 72.8657 40.6399 61.7583 44.2165 61.7583Z"
          fill="#7D6BEB"
        />
        <path
          d="M44.8247 61.7583C46.5347 61.7583 47.7186 61.7583 50.6124 61.7583C53.7973 61.7583 51.4016 70.0889 50.6124 70.0889C49.8232 70.0889 47.7186 73.448 47.7186 73.448C47.7186 73.448 46.0086 70.0889 44.8247 70.0889C43.6409 70.0889 41.8701 61.7583 44.8247 61.7583Z"
          fill="#A799FF"
        />
        <path
          d="M45.737 61.7583C46.907 61.7583 47.717 61.7583 49.697 61.7583C51.8761 61.7583 50.237 67.312 49.697 67.312C49.157 67.312 47.717 69.5514 47.717 69.5514C47.717 69.5514 46.547 67.312 45.737 67.312C44.927 67.312 43.7154 61.7583 45.737 61.7583Z"
          fill="#EDEAFF"
        />
        <path
          d="M41.0895 57.8618H53.9482L53.1689 62.5377H42.2585L41.0895 57.8618Z"
          fill="url(#paint0_linear_600_30739)"
        />
        <path
          d="M41.2126 18.1209C41.2126 21.5398 43.984 24.3112 47.4029 24.3112C50.8217 24.3112 53.5931 21.5398 53.5931 18.1209C53.5931 14.7021 50.8217 11.9307 47.4029 11.9307C43.984 11.9307 41.2126 14.7021 41.2126 18.1209Z"
          fill="url(#paint1_linear_600_30739)"
        />
        <path
          d="M44.5218 32.0318L47.2494 27.8579L49.977 32.0318L47.2494 58.6407L44.5218 32.0318Z"
          fill="#7C6AEA"
        />
        <defs>
          <filter
            id="filter0_f_600_30739"
            x="17.5073"
            y="70.3204"
            width="60.7223"
            height="18.8998"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="2.57003"
              result="effect1_foregroundBlur_600_30739"
            />
          </filter>
          <linearGradient
            id="paint0_linear_600_30739"
            x1="40.6198"
            y1="60.781"
            x2="43.1426"
            y2="53.8487"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#53E5D6" />
            <stop offset="0.8695" stopColor="#40BAD6" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_600_30739"
            x1="41.1913"
            y1="11.4803"
            x2="53.6631"
            y2="20.9278"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#53E5D6" />
            <stop offset="0.8695" stopColor="#40BAD6" />
          </linearGradient>
        </defs>
      </svg>
    </Conditional>
    <Conditional if={type === 'error'}>
      <svg
        width="89"
        height="90"
        viewBox="0 0 89 90"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse
          cx="14.2939"
          cy="1.77678"
          rx="1.77996"
          ry="1.77678"
          fill="#FFCFCF"
        />
        <path
          d="M4.9902 54.6243C4.9902 55.2772 4.45973 55.8078 3.80387 55.8078C3.148 55.8078 2.61753 55.2772 2.61753 54.6243C2.61753 53.9713 3.148 53.4408 3.80387 53.4408C4.45973 53.4408 4.9902 53.9713 4.9902 54.6243Z"
          stroke="#FFCFCF"
          strokeWidth="0.791706"
        />
        <path
          d="M88.5153 25.5284C88.5153 26.0244 88.0362 26.5145 87.329 26.5145C86.6218 26.5145 86.1427 26.0244 86.1427 25.5284C86.1427 25.0324 86.6218 24.5423 87.329 24.5423C88.0362 24.5423 88.5153 25.0324 88.5153 25.5284Z"
          stroke="#FFCFCF"
          strokeWidth="0.791706"
        />
        <ellipse
          cx="72.4848"
          cy="50.0714"
          rx="1.38441"
          ry="1.38194"
          fill="#FFCFCF"
        />
        <path
          d="M58.2062 7.92787L58.2062 5.93369L58.2043 5.90281C58.1851 5.75921 58.0679 5.65603 57.9287 5.65603C57.7884 5.65603 57.6707 5.76075 57.6534 5.89898L57.6515 5.92754L57.6511 7.92773L55.6586 7.92789L55.6276 7.92977C55.4966 7.94744 55.3989 8.04629 55.3833 8.17084L55.3814 8.1994L55.3831 8.23664C55.4007 8.36766 55.4995 8.46546 55.6239 8.48105L55.6525 8.48301L57.6514 8.48308L57.6513 10.4774L57.6529 10.5059C57.6707 10.6503 57.7884 10.7551 57.9287 10.7551L57.9572 10.7535L57.9855 10.7486C58.115 10.7198 58.2062 10.6084 58.2062 10.4774L58.2063 8.48308L60.1988 8.4832L60.2273 8.48162C60.3716 8.46375 60.4763 8.34595 60.4763 8.20555C60.4763 8.0522 60.352 7.92789 60.1988 7.92789L58.2062 7.92787Z"
          fill="#FFCFCF"
        />
        <path
          d="M36.9322 67.5338L36.9322 66.0108L36.9307 65.9872C36.916 65.8776 36.8263 65.7988 36.7197 65.7988C36.6123 65.7988 36.5222 65.8788 36.5089 65.9843L36.5074 66.0061L36.5072 67.5337L34.9815 67.5339L34.9578 67.5353C34.8575 67.5488 34.7827 67.6243 34.7708 67.7194L34.7693 67.7412L34.7705 67.7697C34.7841 67.8697 34.8597 67.9444 34.955 67.9563L34.9768 67.9578L36.5074 67.9579L36.5073 69.481L36.5085 69.5028C36.5222 69.6131 36.6123 69.693 36.7197 69.693L36.7416 69.6918L36.7632 69.6881C36.8624 69.6661 36.9322 69.5811 36.9322 69.481L36.9323 67.9579L38.4579 67.958L38.4797 67.9568C38.5902 67.9431 38.6703 67.8531 38.6703 67.7459C38.6703 67.6288 38.5752 67.5339 38.4579 67.5339L36.9322 67.5338Z"
          fill="#FFCFCF"
        />
        <path
          d="M2.42386 24.4553L2.42385 22.8151L2.42232 22.7898C2.40646 22.6716 2.30988 22.5868 2.19507 22.5868C2.07939 22.5868 1.98233 22.6729 1.96808 22.7866L1.96645 22.8101L1.96617 24.4552L0.323177 24.4553L0.297565 24.4569C0.18961 24.4714 0.109028 24.5527 0.0961841 24.6552L0.0945631 24.6786L0.0959539 24.7093C0.110511 24.817 0.191958 24.8975 0.294587 24.9103L0.318116 24.9119L1.9664 24.912L1.9663 26.5522L1.9676 26.5757C1.98233 26.6945 2.07939 26.7806 2.19507 26.7806L2.21859 26.7793L2.24193 26.7753C2.34868 26.7516 2.42385 26.66 2.42385 26.5522L2.42397 24.912L4.06697 24.9121L4.09048 24.9108C4.20945 24.8961 4.29574 24.7992 4.29574 24.6837C4.29574 24.5576 4.19331 24.4553 4.06696 24.4553L2.42386 24.4553Z"
          fill="#FFCFCF"
        />
        <g filter="url(#filter0_f_1056_31679)">
          <path
            d="M73.0893 79.7709C73.0893 82.1512 61.7975 84.0808 47.8683 84.0808C33.9391 84.0808 22.6472 82.1512 22.6472 79.7709C22.6472 77.3906 33.9391 75.4609 47.8683 75.4609C61.7975 75.4609 73.0893 77.3906 73.0893 79.7709Z"
            fill="#FFCFCF"
            fillOpacity="0.29"
          />
        </g>
        <path
          d="M66.6733 31.5845L57.4549 27.4688V45.1981L69.5342 52.7964L66.6733 31.5845Z"
          fill="#980000"
        />
        <path
          d="M28.4769 31.5845L36.8032 27.4688V45.1981L25.8928 52.7964L28.4769 31.5845Z"
          fill="#980000"
        />
        <path
          d="M47.324 52.8153V49.0301V45.2449V4.86914C47.324 4.86914 41.4367 7.37613 37.4333 19.2843C35.1303 26.135 34.0855 32.5313 33.4989 39.2516C33.122 43.5702 33.3319 48.0838 33.636 52.8153H36.3736V55.3388H39.5824V57.8623H47.324V55.3388V52.8153Z"
          fill="#FFC8C8"
        />
        <path
          d="M47.324 52.8153V49.0301L47.324 45.2449L47.324 4.86914C47.324 4.86914 53.3748 7.37613 57.4894 19.2843C59.8564 26.135 60.9302 32.5313 61.5331 39.2516C61.9205 43.5702 61.7048 48.0838 61.3921 52.8153H58.5785V55.3388H55.2806V57.8623H47.324V55.3388V52.8153Z"
          fill="#FFE7E7"
        />
        <path
          d="M44.2164 61.7598C46.2863 61.7598 47.7194 61.7598 51.2225 61.7598C55.0778 61.7598 52.1778 72.8672 51.2225 72.8672C50.2671 72.8672 47.7194 77.346 47.7194 77.346C47.7194 77.346 45.6494 72.8672 44.2164 72.8672C42.7833 72.8672 40.6397 61.7598 44.2164 61.7598Z"
          fill="#980000"
        />
        <path
          d="M44.8246 61.7598C46.5345 61.7598 47.7184 61.7598 50.6122 61.7598C53.7971 61.7598 51.4014 70.0903 50.6122 70.0903C49.823 70.0903 47.7184 73.4494 47.7184 73.4494C47.7184 73.4494 46.0084 70.0903 44.8246 70.0903C43.6407 70.0903 41.8699 61.7598 44.8246 61.7598Z"
          fill="#FEB2B2"
        />
        <path
          d="M45.7369 61.7598C46.9068 61.7598 47.7168 61.7598 49.6968 61.7598C51.8759 61.7598 50.2368 67.3135 49.6968 67.3135C49.1568 67.3135 47.7168 69.5529 47.7168 69.5529C47.7168 69.5529 46.5468 67.3135 45.7369 67.3135C44.9269 67.3135 43.7153 61.7598 45.7369 61.7598Z"
          fill="#FFE7E7"
        />
        <path
          d="M41.0894 57.8633H53.948L53.1687 62.5391H42.2583L41.0894 57.8633Z"
          fill="url(#paint0_linear_1056_31679)"
        />
        <path
          d="M41.2124 18.1219C41.2124 21.5407 43.9839 24.3122 47.4027 24.3122C50.8215 24.3122 53.593 21.5407 53.593 18.1219C53.593 14.7031 50.8215 11.9316 47.4027 11.9316C43.9839 11.9316 41.2124 14.7031 41.2124 18.1219Z"
          fill="url(#paint1_linear_1056_31679)"
        />
        <path
          d="M44.5217 32.0333L47.2493 27.8594L49.9769 32.0333L47.2493 58.6422L44.5217 32.0333Z"
          fill="#980000"
        />
        <defs>
          <filter
            id="filter0_f_1056_31679"
            x="17.5072"
            y="70.3209"
            width="60.7223"
            height="18.8993"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="2.57003"
              result="effect1_foregroundBlur_1056_31679"
            />
          </filter>
          <linearGradient
            id="paint0_linear_1056_31679"
            x1="41.0672"
            y1="57.6932"
            x2="46.0865"
            y2="68.4649"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.42" stopColor="#FEB2B2" />
            <stop offset="0.8695" stopColor="#FF9797" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1056_31679"
            x1="41.1911"
            y1="11.4813"
            x2="58.0275"
            y2="24.6202"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.42" stopColor="#FEB2B2" />
            <stop offset="0.8695" stopColor="#FF9797" />
          </linearGradient>
        </defs>
      </svg>
    </Conditional>
  </>
);

export default Rocket;
